import { falseFunction } from "./helpers";
import Fetcher from "../fetcher";
import { getValueAtPath } from "../utils";
import {
  DEFAULT_POST_INIT,
  DEFAULT_RETRY_CONDITIONS,
  DEFAULT_TIMEOUT,
  isJsonResponse,
  withSharedHeaders
} from "../fetcher/utils";
import Store from "../context";
import CampaignState from "../context/common/campaign";
import InfoState from "../context/common/info";

const CARD_DISCOUNT = Object.create(null);

const $fetcher = withSharedHeaders(Fetcher.one
  .limit(3)
  .init(DEFAULT_POST_INIT)
  .retry(DEFAULT_RETRY_CONDITIONS)
  .timeout(DEFAULT_TIMEOUT));

function getCardDiscount(context, card6) {
    const { dispatch } = Store;

    const currency = getValueAtPath(context, 'DATA.currency');
    const amount = getValueAtPath(context, 'DATA.amount');
    const public_key = getValueAtPath(context, 'DATA.PBFPubKey');
    const meta_data = getValueAtPath(context, 'DATA.meta');
    const meta = {};
    const keysToExtract = ["discount", "type", "percentage"];
    
    const valueTransform = {
        percentage: val => parseFloat(val),
    };

    keysToExtract.forEach(key => {
        const match = meta_data?.find(item => item.metaname === key);
        if (match) {
            const transform = valueTransform[key];
            meta[key] = transform ? transform(match.metavalue) : match.metavalue;
        }
    });

    meta.preferences = {
        custom_merchant_discount: 1
    }

    let cache_key = btoa(`discount::${currency}::${card6}::${amount}`);

    if (CARD_DISCOUNT[cache_key]) {
        dispatch(CampaignState.actions.updateCampaign({...CARD_DISCOUNT[cache_key]}));
        return Promise.resolve(CARD_DISCOUNT[cache_key])
    };

    dispatch(InfoState.actions.updateInfo({ amountUpdate: true }));

    return $fetcher(new URL('v3/checkout/custom-discount', process.env.API_BASE_URL), {
        body: JSON.stringify({
            public_key,
            payment_method: card6,
            meta,
            amount,
            currency
        })
      }).then(response => {
            if (isJsonResponse(response) && response.ok) {
                return response.json()
                    .then(response => {
                        const discountData = { ...response.data.discount_data };

                        Object.defineProperty(CARD_DISCOUNT, cache_key, {
                            value: discountData
                        });

                        // Update campaign state with discount data
                        if (discountData) {
                            dispatch(CampaignState.actions.updateCampaign(discountData));
                        }

                        return CARD_DISCOUNT[cache_key];
                    })
            }
        }).catch(falseFunction)
}

export default getCardDiscount;
